var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-box',{attrs:{"isError":_vm.error,"isBusy":_vm.busy},on:{"handleSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }